import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { TableChart, ViewKanban } from "@mui/icons-material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/common/Loader";
import { useGetTasksQuery } from "../../services/tasks.service";
import { useGetUsersQuery } from "../../services/users.service";
import TasksTable from "../../components/Tasks/Table";
import TasksKanbanBoard from "../../components/Tasks/TasksKanbanBoard";

type View = "table" | "kanban";

function TasksPage() {
  const navigator = useNavigate();
  const [view, setView] = useState<View>("table");

  const { data, error, isLoading } = useGetTasksQuery("Tasks");
  const { data: users, error: usersError, isLoading: isLoadingUsers } = useGetUsersQuery("Users");

  if (error || usersError) {
    navigator("/");
  }

  if (isLoading || isLoadingUsers) {
    return <Loader />;
  }

  return (
    <Box height="100%" width="100%" display="flex" flexDirection="column" gap={1.5}>
      <Box sx={{ display: "flex", justifyContent: "flex-end", flexShrink: 0 }}>
        <ToggleButtonGroup
          size="small"
          value={view}
          exclusive
          onChange={(_, val) => val && setView(val)}
          sx={{ height: 36 }}
        >
          <ToggleButton value="table" sx={{ px: 1.5, gap: 0.5, fontSize: "0.75rem", fontWeight: 600, textTransform: "none" }}>
            <TableChart fontSize="small" />
            Table
          </ToggleButton>
          <ToggleButton value="kanban" sx={{ px: 1.5, gap: 0.5, fontSize: "0.75rem", fontWeight: 600, textTransform: "none" }}>
            <ViewKanban fontSize="small" />
            Kanban
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>

      <Box flex={1} minHeight={0}>
        {view === "table" ? (
          <TasksTable rows={data!} />
        ) : (
          <TasksKanbanBoard tasks={data!} users={users!} />
        )}
      </Box>
    </Box>
  );
}

export default TasksPage;
